import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-prazo-grid', grid)
Vue.component('app-prazo-edit', edit)
Vue.component('app-prazo-select', select)
